import React, { Component } from 'react'
import { TextField, Popper } from '@material-ui/core'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import { withTranslation } from 'react-i18next'
import equal from 'fast-deep-equal'
import PropTypes from 'prop-types'

const filter = createFilterOptions({ stringify: (option) => option.label })

const styles = (theme) => ({
    popper: {
        width: 'fit-content',
    },
})

const PopperCustom = function(props) {
    return <Popper {...props} style={styles.popper} placement="bottom-start" />
}

/**
 * 
 * options : [{
        key,
        label: elem.name,
        value: key,
    }]
 */

class CmsAutocomplete extends Component {
    constructor(props) {
        super(props)
        this.state = {
            inputValue: '' /** 使用者搜尋關鍵字 */,
            preSelectValue: '' /** 紀錄上一次選擇狀態 */,
            isKeywordOnChange: false /** 判斷是否為使用者修改 */,
        }
    }
    optionMap = {}
    componentDidMount() {
        this.setOptionList()
    }
    allOption = {
        key: 'all',
        label: this.props.allLabel,
        value: 'all',
    }
    getOptionList = () => {
        return this.props.allOption ? [this.allOption, ...this.props.options] : this.props.options
    }

    setOptionList = () => {
        this.optionMap = this.props.options.reduce((pre, item) => {
            pre[item.value] = item
            return pre
        }, {})
        if (this.props.allOption) {
            this.optionMap['all'] = this.allOption
        }

        const inputValue = this.props.value === 'all' ? this.props.allLabel : this.optionMap?.[this.props.value]?.label ?? this.props.value

        this.setState({
            inputValue,
            preSelectValue: inputValue,
            isKeywordOnChange: false,
        })
    }

    onChange = (event, option) => {
        /** 點擊選項 */
        this.setState(
            {
                inputValue: option.label,
                preSelectValue: option.label,
                isKeywordOnChange: false,
            },
            () => {
                this.autoRef.blur()
                this.props.onChange(option)
            }
        )
    }

    filterOptions = (options, params) => {
        /** 自定義搜尋條件 */
        const filtered = filter(options, params)
        /** 處理未修改關鍵字時, 預設全部選項 */
        return this.state.inputValue === this.state.preSelectValue && !this.state.isKeywordOnChange ? options : filtered
    }

    onInputChange = (event, newInputValue) => {
        /** 關鍵字搜尋 */
        const InputChangeType = event?.type === 'change'
        const InputBlur = event?.type === 'blur'
        if (InputChangeType) {
            this.setState({ inputValue: newInputValue, isKeywordOnChange: true })
        }
        if (InputBlur) {
            this.setState({ inputValue: this.state.preSelectValue, isKeywordOnChange: false })
        }
    }

    componentDidUpdate(prevProps) {
        if (!equal(prevProps.options, this.props.options)) {
            this.setOptionList()
        }
        /** 切換語系同步input值 */
        if (this.props.allOption && this.props.value === 'all' && this.props.t !== prevProps.t && !this.state.isKeywordOnChange) {
            this.setState({
                inputValue: this.props.allLabel,
                preSelectValue: this.props.allLabel,
            })
        }
    }

    render() {
        const { value, getOptionLabel, renderOption, inputClassName, label, placeholder = '' } = this.props

        return (
            <Autocomplete
                PopperComponent={PopperCustom}
                value={value}
                disableClearable
                onChange={this.onChange}
                filterOptions={this.filterOptions}
                inputValue={this.state.inputValue}
                onInputChange={this.onInputChange}
                options={this.getOptionList()}
                getOptionLabel={getOptionLabel}
                renderOption={renderOption}
                renderInput={(params) => {
                    return (
                        <TextField
                            {...params}
                            className={inputClassName}
                            inputRef={(e) => (this.autoRef = e)}
                            label={label}
                            placeholder={placeholder}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    )
                }}
            />
        )
    }
}

CmsAutocomplete.propTypes = {
    allLabel: PropTypes.string,
    allOption: PropTypes.bool,
    options: PropTypes.array.isRequired,
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    t: PropTypes.func,
    getOptionLabel: PropTypes.func,
    renderOption: PropTypes.func,
    inputClassName: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
}

export default withTranslation()(CmsAutocomplete)
